import { FC, useState } from 'react';
import { Modal } from 'components';
import SectionStyled, { ContentStyled } from './styles';

const DeleteAppointment: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const okButton = {
    text: '削除',
    onClick: () => setVisible(false),
  };
  const cancelButton = {
    text: 'キャンセル',
    onClick: () => setVisible(false),
  };
  return (
    <SectionStyled>
      <button onClick={() => setVisible(true)}>Open Modal Delete Appointment</button>
      <Modal
        title="予定を削除します。作業員の該当現場の予定が全て削除されます。よろしいですか？"
        visible={visible}
        width={640}
        okButton={okButton}
        cancelButton={cancelButton}
      >
        <ContentStyled>この操作は元に戻せません</ContentStyled>
      </Modal>
    </SectionStyled>
  );
};
export default DeleteAppointment;
